<template>
  <ViewerItem
    :model_id="contractStock.stock_id"
    type="StockCalculator"
    show_type="drawer"
    :tip="false"
    class="link"
  >
    最佳采购量计算
  </ViewerItem>
</template>
<script>
  import ViewerItem from '@/views/components/viewer/item';
  export default {
    components: {
      ViewerItem
    },
    props: {
      contractStock: {
        type: Object,
      }
    }
  }
</script>
